import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { createRoot } from "react-dom/client";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import Scheduler from "./Scheduler";
import { initializei18Next } from "./i18n/i18n";
import { initializeLogRocket } from "./utils/logRocket";
import "./assets/accessibility.css";

const theme = createTheme({
  cssVariables: {
    colorSchemeSelector: "data-mui-color-scheme"
  },
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: "#2b5a94",
          contrastText: "#ffffff"
        }
      }
    },
    dark: {
      palette: {
        primary: {
          main: "#FF9F09",
          contrastText: "#000000"
        }
      }
    }
  }
});

initializeLogRocket();
initializei18Next();

// biome-ignore lint/style/noNonNullAssertion: <explanation>
createRoot(document.getElementById("root")!).render(
  <ThemeProvider theme={theme} defaultMode="dark">
    <CssBaseline />
    <Scheduler />
  </ThemeProvider>
);
